import { Suspense } from 'react';
import { Route } from 'react-router-dom';
import ErrorBoundary from '@/components/ErrorBoundary';
import { LoadingSpinner } from '@/app/LoadingSpinner';
import { ModuleGuard, P } from '@/app/guards';
import {
  EcranClient,
  Caracteristiques,
  Classifications,
  Commentaires,
  ComptesBancaires,
  DelaisPaiement,
  Devises,
  Familles,
  FamillesClients,
  FamillesFournisseurs,
  FamillesTarifaires,
  FondsCaisse,
  Libelles,
  Marques,
  ModesReglement,
  ModuleManagement,
  ProfilsComptables,
  ProfilsTVA,
  Provenances,
  SousFamilles,
  Taxes,
  TypesMouvement,
  Variantes,
} from '@/app/lazyPages';

/**
 * Groupe de routes extrait d'App.tsx (strangler 1b) — ordre source préservé.
 * Table de routes déclarative : dépasse volontairement max-lines-per-function (warn).
 */
export function configCatalogRoutes() {
  return (
    <>
      {/* Configuration */}
      <Route
        path="/config/modules"
        element={
          <P>
            <ErrorBoundary>
              <Suspense fallback={<LoadingSpinner />}>
                <ModuleManagement />
              </Suspense>
            </ErrorBoundary>
          </P>
        }
      />
      <Route
        path="/config/ecran-client"
        element={
          <P>
            <ModuleGuard modules={['mod_ecran_client']}>
              <ErrorBoundary>
                <Suspense fallback={<LoadingSpinner />}>
                  <EcranClient />
                </Suspense>
              </ErrorBoundary>
            </ModuleGuard>
          </P>
        }
      />
      <Route
        path="/config/familles"
        element={
          <P>
            <ErrorBoundary>
              <Suspense fallback={<LoadingSpinner />}>
                <Familles />
              </Suspense>
            </ErrorBoundary>
          </P>
        }
      />
      <Route
        path="/config/sous-familles"
        element={
          <P>
            <ErrorBoundary>
              <Suspense fallback={<LoadingSpinner />}>
                <SousFamilles />
              </Suspense>
            </ErrorBoundary>
          </P>
        }
      />
      <Route
        path="/config/marques"
        element={
          <P>
            <ErrorBoundary>
              <Suspense fallback={<LoadingSpinner />}>
                <Marques />
              </Suspense>
            </ErrorBoundary>
          </P>
        }
      />
      <Route
        path="/config/classifications-1"
        element={
          <P>
            <ErrorBoundary>
              <Suspense fallback={<LoadingSpinner />}>
                <Classifications level={1} />
              </Suspense>
            </ErrorBoundary>
          </P>
        }
      />
      <Route
        path="/config/classifications-2"
        element={
          <P>
            <ErrorBoundary>
              <Suspense fallback={<LoadingSpinner />}>
                <Classifications level={2} />
              </Suspense>
            </ErrorBoundary>
          </P>
        }
      />
      <Route
        path="/config/classifications-3"
        element={
          <P>
            <ErrorBoundary>
              <Suspense fallback={<LoadingSpinner />}>
                <Classifications level={3} />
              </Suspense>
            </ErrorBoundary>
          </P>
        }
      />
      <Route
        path="/config/caracteristiques"
        element={
          <P>
            <ErrorBoundary>
              <Suspense fallback={<LoadingSpinner />}>
                <Caracteristiques />
              </Suspense>
            </ErrorBoundary>
          </P>
        }
      />
      <Route
        path="/config/variantes"
        element={
          <P>
            <ErrorBoundary>
              <Suspense fallback={<LoadingSpinner />}>
                <Variantes />
              </Suspense>
            </ErrorBoundary>
          </P>
        }
      />
      <Route
        path="/config/familles-clients"
        element={
          <P>
            <ErrorBoundary>
              <Suspense fallback={<LoadingSpinner />}>
                <FamillesClients />
              </Suspense>
            </ErrorBoundary>
          </P>
        }
      />
      <Route
        path="/config/familles-fournisseurs"
        element={
          <P>
            <ErrorBoundary>
              <Suspense fallback={<LoadingSpinner />}>
                <FamillesFournisseurs />
              </Suspense>
            </ErrorBoundary>
          </P>
        }
      />
      <Route
        path="/config/familles-tarifaires"
        element={
          <P>
            <ErrorBoundary>
              <Suspense fallback={<LoadingSpinner />}>
                <FamillesTarifaires />
              </Suspense>
            </ErrorBoundary>
          </P>
        }
      />
      <Route
        path="/config/provenances"
        element={
          <P>
            <ErrorBoundary>
              <Suspense fallback={<LoadingSpinner />}>
                <Provenances />
              </Suspense>
            </ErrorBoundary>
          </P>
        }
      />
      <Route
        path="/config/commentaires"
        element={
          <P>
            <ErrorBoundary>
              <Suspense fallback={<LoadingSpinner />}>
                <Commentaires />
              </Suspense>
            </ErrorBoundary>
          </P>
        }
      />
      <Route
        path="/config/libelles"
        element={
          <P>
            <ErrorBoundary>
              <Suspense fallback={<LoadingSpinner />}>
                <Libelles />
              </Suspense>
            </ErrorBoundary>
          </P>
        }
      />
      <Route
        path="/config/types-mouvement"
        element={
          <P>
            <ErrorBoundary>
              <Suspense fallback={<LoadingSpinner />}>
                <TypesMouvement />
              </Suspense>
            </ErrorBoundary>
          </P>
        }
      />
      <Route
        path="/config/modes-reglement"
        element={
          <P>
            <ErrorBoundary>
              <Suspense fallback={<LoadingSpinner />}>
                <ModesReglement />
              </Suspense>
            </ErrorBoundary>
          </P>
        }
      />
      <Route
        path="/config/delais-paiement"
        element={
          <P>
            <ErrorBoundary>
              <Suspense fallback={<LoadingSpinner />}>
                <DelaisPaiement />
              </Suspense>
            </ErrorBoundary>
          </P>
        }
      />
      <Route
        path="/config/fonds-caisse"
        element={
          <P>
            <ErrorBoundary>
              <Suspense fallback={<LoadingSpinner />}>
                <FondsCaisse />
              </Suspense>
            </ErrorBoundary>
          </P>
        }
      />
      <Route
        path="/config/profils-comptables"
        element={
          <P>
            <ErrorBoundary>
              <Suspense fallback={<LoadingSpinner />}>
                <ProfilsComptables />
              </Suspense>
            </ErrorBoundary>
          </P>
        }
      />
      <Route
        path="/config/profils-tva"
        element={
          <P>
            <ErrorBoundary>
              <Suspense fallback={<LoadingSpinner />}>
                <ProfilsTVA />
              </Suspense>
            </ErrorBoundary>
          </P>
        }
      />
      <Route
        path="/config/taxes"
        element={
          <P>
            <ErrorBoundary>
              <Suspense fallback={<LoadingSpinner />}>
                <Taxes />
              </Suspense>
            </ErrorBoundary>
          </P>
        }
      />
      <Route
        path="/config/comptes-bancaires"
        element={
          <P>
            <ErrorBoundary>
              <Suspense fallback={<LoadingSpinner />}>
                <ComptesBancaires />
              </Suspense>
            </ErrorBoundary>
          </P>
        }
      />
      <Route
        path="/config/devises"
        element={
          <P>
            <ErrorBoundary>
              <Suspense fallback={<LoadingSpinner />}>
                <Devises />
              </Suspense>
            </ErrorBoundary>
          </P>
        }
      />
    </>
  );
}
